import HttpClient from '@/utils/HttpClient';
import projectStore from '@/store/Projects';
export default {
  getAllocationUnits(projectId) {
    return HttpClient.getAuthenticated(`/api/projects/${projectId}/allocationunits`);
  },
  getAllocationUnitsSimple() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/allocationunitssimple`);
  },
  getAllocationUnitsWOOrders() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/allocationunitsWOorders`);
  },
  getAllocationUnitsWOOrdersIncl(veId) {
    return HttpClient.getAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunitsWOorders/${veId}`
    );
  },
  getAllocationUnitsWithQuotes(projectId) {
    return HttpClient.getAuthenticated(`/api/projects/${projectId}/allocationunitswithquotes`);
  },
  getAllocationUnitById(dbId) {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/allocationunits/${dbId}`);
  },
  getById(id) {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/allocationunits/${id}`);
  },
  hasObjects(id) {
    return HttpClient.getAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/${id}/hasObjects`
    );
  },
  hasObjectsList(idList) {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/allocationunits/hasObjects`, {
      idList
    });
  },
  getAllocationUnitByOrderId(projectId, dbId) {
    return HttpClient.getAuthenticated(`/api/projects/${projectId}/orders/${dbId}/allocationunit`);
  },
  getAllocationUnitAllocations(VeDbId) {
    return HttpClient.getAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/${VeDbId}/allocations`
    );
  },
  getAllocationUnitQuotes(VeDbId) {
    return HttpClient.getAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/${VeDbId}/quotes`
    );
  },
  deleteQuote(VeDbId, QuoteDbId) {
    return HttpClient.deleteAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/${VeDbId}/quotes/${QuoteDbId}`
    );
  },
  createNewAllocationUnit(projectId, allocationUnit, cb) {
    HttpClient.postAuthenticated(`/api/projects/${projectId}/allocationunits`, { allocationUnit: allocationUnit })
      .then(result => {
        return cb(null, result[0]);
      })
      .catch(err => cb(err, null));
  },
  createNewQuote(quote) {
    return HttpClient.postAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/${quote.VeDbId}/quotes`,
      { quote }
    );
  },
  updateQuote(quote) {
    return HttpClient.updateAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/${quote.VeDbId}/quotes/${quote.DbId}`,
      { quote }
    );
  },
  createBulk(projectId, allocationUnits, overwriteOption) {
    return HttpClient.postAuthenticated(`/api/projects/${projectId}/allocationunits`, {
      allocationUnits,
      overwriteOption
    });
  },
  createFromCostGroups(prefix) {
    return HttpClient.postAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/fromcostgroups`,
      { prefix }
    );
  },
  createAllocation(allocation) {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/allocations`, { allocation });
  },
  deleteAllocationUnit(projectId, allocationUnitDbId, cb) {
    HttpClient.deleteAuthenticated(`/api/projects/${projectId}/allocationunits/${allocationUnitDbId}`)
      .then(() => cb())
      .catch(err => cb(err));
  },
  deleteAllocationUnits(allocationUnits) {
    return HttpClient.deleteAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits`,
      allocationUnits
    );
  },
  deleteAllocation(allocation) {
    return HttpClient.deleteAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocations/${allocation.Source}/${allocation.RefDbId}`,
      { allocation }
    );
  },
  updateAllocationUnit(allocationUnit) {
    return HttpClient.updateAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/${allocationUnit.DbId}`,
      { allocationUnit }
    );
  },
  updateAllocation(allocation) {
    return HttpClient.updateAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocations/${allocation.Source}/${allocation.RefDbId}`,
      { allocation }
    );
  },
  selectQuote(allocationUnitId, selectedQuoteId, active) {
    // /projects/:projectId/allocationunits/:allocationUnitId/quotes/:quoteDbId/select
    return HttpClient.postAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/${allocationUnitId}/quotes/${selectedQuoteId}/select`,
      { active }
    );
  },
  checkBudget(VeDbId, budgetDemanded) {
    return HttpClient.postAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocationunits/${VeDbId}/budget`,
      { budgetDemanded }
    );
  }
};
